// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3_FX4","title":"ClientInsurance_title__1vqTh","itemText":"ClientInsurance_itemText__1lzIg"};